//synchronous action creators
export const showOrHideSignupModal = () => {
    
    return {
        type: "CLICKED_SIGNUP"
    }
}